import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fold-fill",
  "use": "icon-fold-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fold-fill\">\n<path d=\"M1.5 8.625H22.4961L22.5 18.75C22.5 19.3711 21.9102 19.875 21.1875 19.875H2.8125C2.08594 19.875 1.5 19.3711 1.5 18.75V8.625ZM22.5 7.5H1.5V5.25C1.5 4.62891 2.08594 4.125 2.8125 4.125H8.42188C8.98047 4.125 9.51562 4.31641 9.90625 4.65234L11.3008 5.84766C11.6953 6.18359 12.2305 6.375 12.7891 6.375H21.1875C21.9141 6.375 22.5 6.87891 22.5 7.5Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/fold-fill.svg
// module id = kTSR
// module chunks = 262